





















declare var window: any;
import { vxm } from '@/store.vuex';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ProfessionalReferenceShortForm from './ProfessionalReferenceShortForm.vue';
import ProfessionalReferenceLongForm from './ProfessionalReferenceLongForm.vue';
@Component({
  components: {
    ProfessionalReferenceShortForm,
    ProfessionalReferenceLongForm,
  },
})
export default class ProfessionalReference extends Vue {
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  @Prop () isLastStep;
  get isLongFormEnabled() {
    return vxm.configs.getGlobalConfigValue('ENABLE_PROFESSIONAL_REFERENCE_LONG_FORM')
  }
  disableNext(val) {
    this.$emit('disable-next-button', val);
  }

  async goToNext() {
    await vxm.users.validateMandatorySteps();
    if(vxm.users.MissedMandatorySteps.length && this.isLastStep) {
          this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
        }else{
          this.$emit('go-to-next');
        }
  }
  async mounted() {
    if (!(this.$router.currentRoute.name === 'GuidedSignup')) {
      await vxm.users.fetchWizardSteps();
    }
  }
}
